export const MORE_INFO_COPY = {
  moreInfo: 'More Info',
  summary: 'Summary',
  description: 'Description',
  button: 'Okay',
};
